<template>
  <container :class="[baseCss]" :tag="tag" :style="style">
    <slot />
  </container>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'MultilineEllipsis',
  mixins: [
    methods
  ],
  data () {
    return {
      clamp: null,
      baseCss: this.componentBaseCss('multiline-ellipsis', [])
    }
  },
  computed: {
    style () {
      const lineClamp = this.clamp
      return {
        lineClamp,
        webkitLineClamp: lineClamp,
        mozLineClamp: lineClamp
      }
    }
  },
  props: {
    lineClamp: {
      type: Number
    },
    tag: {
      type: String,
      default: 'p'
    }
  },
  watch: {
    lineClamp () {
      this.init()
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      this.clamp = this.lineClamp
    }
  }
}
</script>
<style>
.bcq-multiline-ellipsis
{
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box !important;
  -webkit-box-orient: vertical;
  white-space: normal;
}
</style>



// WEBPACK FOOTER //
// src/bcq-ui/components/multiline-ellipsis/multiline-ellipsis.vue